<template>
  <div class="container">
    <h1>Orionに登録済み/登録希望のデータ確認</h1>
    <p>
      CKANに格納しているOrionへの連携希望のデータおよび既に登録されているデータを以下に記載します。
    </p>
    <p class="errorMsg" v-if="errorFlag">
      読み込みに失敗しました。<br />
      時間を置いて再度ご確認ください。
    </p>
    <div class="nonTable" v-if="this.selected_data.length != 0">
      <div class="fillterSpase">
        <v-card class="card">
          <div class="cardTitle" @click="this.show = !this.show">
            <v-icon icon="mdi-filter-outline" class="filterIcon"></v-icon>
            <p class="filterTitle">絞り込み</p>
            <v-icon
              icon="mdi-chevron-down"
              class="arrowIcon"
              v-show="!this.show"
            ></v-icon>
            <v-icon
              icon="mdi-chevron-up"
              class="arrowIcon"
              v-show="this.show"
            ></v-icon>
          </div>
          <v-expand-transition class="expand">
            <div v-show="show">
              <v-divider></v-divider>
              <div class="fillter">
                <v-select
                  v-model="selectedCategory"
                  :items="largeCategory"
                  Chips
                  label="大分類"
                  persistent-hint
                  variant="underlined"
                ></v-select>
                <v-select
                  v-model="selectedSmc"
                  :items="smc"
                  Chips
                  label="中小分類"
                  persistent-hint
                  variant="underlined"
                  v-bind:disabled="categorySelected"
                ></v-select>
                <v-checkbox
                  label="未登録のみにする"
                  v-model="unregistered"
                ></v-checkbox>
                <v-btn @click="search()" class="bg-blue-lighten-1">検索</v-btn>
                <v-btn @click="clear()" class="bg-grey-lighten-3">クリア</v-btn>
              </div>
            </div>
          </v-expand-transition>
        </v-card>
      </div>
      <div class="validateSpace">
        <v-card class="card">
          <div
            class="cardTitle"
            @click="this.showValidate = !this.showValidate"
          >
            <v-icon icon="mdi-calendar-arrow-right" class="filterIcon"></v-icon>
            <p class="filterTitle">検証/次回登録予定</p>
            <v-icon
              icon="mdi-chevron-down"
              class="arrowIcon"
              v-show="!this.showValidate"
            ></v-icon>
            <v-icon
              icon="mdi-chevron-up"
              class="arrowIcon"
              v-show="this.showValidate"
            ></v-icon>
          </div>
          <v-expand-transition class="expand">
            <div v-show="showValidate">
              <div class="validate">
                <v-divider></v-divider>
                <v-btn @click="validate()" class="bg-blue-lighten-1"
                  >検証</v-btn
                >
                <v-divider></v-divider>
                <p>次回の更新予定</p>
                <p class="time">{{ nextUpload }}</p>
              </div>
            </div>
          </v-expand-transition>
        </v-card>
      </div>
    </div>
    <div class="table">
      <div class="alert">
        <v-alert
          v-model="alert"
          border="start"
          variant="tonal"
          closable
          close-label=""
          color="red-accent-4"
          title="一致するアイテム無し"
        >
          検索した条件に一致するアイテムが1つもありませんでした。
          検索方法をご確認ください。
        </v-alert>
      </div>
      <loading
        :active="true"
        :is-full-page="false"
        :height="50"
        :opacity="0"
        v-if="this.selected_data.length == 0"
      />
      <div class="nowLoading" v-if="this.selected_data.length == 0">
        <p>Now Loading...</p>
      </div>
      <div class="item" v-if="this.selected_data.length != 0">
        <v-table density="default">
          <thead>
            <tr>
              <th class="text-left font-weight-bold">大分類</th>
              <th class="text-left font-weight-bold">中小分類</th>
              <th class="text-left font-weight-bold">統計表名</th>
              <th class="text-left font-weight-bold">統計表番号</th>
              <th class="text-left font-weight-bold">Orion登録状況</th>
              <th class="text-left font-weight-bold">統計基準日</th>
              <th class="text-left font-weight-bold">CKAN URL</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in selected_data" :key="item.resourceId">
              <td
                class="font-weight-medium"
                :class="[
                  {
                    error: item.largeCategory.includes('エラー'),
                  },
                ]"
              >
                {{ item.largeCategory }}
              </td>
              <td
                class="font-weight-medium"
                :class="[
                  {
                    error: item.smc.includes('エラー'),
                  },
                ]"
              >
                {{ item.smc }}
              </td>
              <td
                class="font-weight-medium"
                :class="[
                  {
                    error: item.packageName.includes('エラー'),
                  },
                ]"
              >
                {{ item.packageName }}
              </td>
              <td
                class="font-weight-medium"
                :class="[
                  {
                    error: item.entityType.includes('エラー'),
                  },
                ]"
              >
                {{ item.entityType }}
              </td>
              <td
                class="font-weight-medium"
                :class="[
                  {
                    error: item.orionUpdate.includes('エラー'),
                  },
                ]"
              >
                {{ item.orionUpdate }}
              </td>
              <td
                class="font-weight-medium"
                :class="[
                  {
                    error: item.dataAcquisitionDate.includes('エラー'),
                  },
                ]"
              >
                {{ item.dataAcquisitionDate }}
              </td>
              <td class="font-weight-medium text-center">
                <a
                  :href="item.ckanUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><v-icon icon="mdi-link"></v-icon
                ></a>
              </td>
            </tr>
          </tbody>
        </v-table>
        <v-pagination v-model="page" :length="pages"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

export default {
  data() {
    return {
      errorFlag: false,
      categorySelected: true,
      show: false,
      showValidate: false,
      pages: 0,
      page: 1,
      perPage: 10,
      items: 0,
      datas: [],
      selected_data: [],
      largeCategory: [],
      smc: [],
      selectedCategory: "",
      selectedSmc: "",
      unregistered: false,
      alert: false,
    };
  },
  watch: {
    page() {
      let tmpArr = [];
      for (let i = 0; i < this.items; i += this.perPage)
        tmpArr.push(this.datas.slice(i, i + this.perPage));
      this.selected_data = tmpArr[this.page - 1];
    },
    selectedCategory() {
      this.selectedSmc = "";
      if (this.selectedCategory == "") {
        this.categorySelected = true;
      } else {
        let tmpArr = [];
        for (let i = 0; i < this.items; i++) {
          if (this.datas[i].largeCategory == this.selectedCategory) {
            tmpArr.push(this.datas[i].smc);
          }
        }
        this.smc = Array.from(new Set(tmpArr));
        this.categorySelected = false;
      }
    },
  },
  methods: {
    clear() {
      this.page = 1;
      this.selectedCategory = "";
      this.selectedSmc = "";
      this.datas = [];
      this.selected_data = [];
      this.unregistered = false;
      axios
        .get("https://api.dataplatform-yamanashi.jp/registration-orion", {
          headers: { Authorization: "Bearer " + this.token },
          params: {
            lc: "",
            sm: "",
            unregistered: this.unregistered,
          },
        })
        .then((response) => {
          this.datas = response.data;
          this.items = this.datas.length;
          this.pages = Math.ceil(this.items / this.perPage);
          let tmpArr = [];
          for (let i = 0; i < this.items; i += this.perPage) {
            tmpArr.push(this.datas.slice(i, i + this.perPage));
          }
          this.selected_data = tmpArr[this.page - 1];
          tmpArr = [];
          for (let i = 0; i < this.items; i++) {
            tmpArr.push(this.datas[i].largeCategory);
          }
          this.largeCategory = Array.from(new Set(tmpArr));
        })
        .catch((error) => {
          console.log(error);
          this.errorFlag = true;
        });
    },
    search() {
      this.page = 1;
      this.datas = [];
      this.selected_data = [];
      axios
        .get("https://api.dataplatform-yamanashi.jp/registration-orion", {
          headers: { Authorization: "Bearer " + this.token },
          params: {
            lc: this.selectedCategory,
            sm: this.selectedSmc,
            unregistered: this.unregistered,
          },
        })
        .then((response) => {
          this.datas = response.data;
          this.items = this.datas.length;
          console.log(this.items);
          if (this.items === 0) {
            this.alert = true;
            this.clear();
          } else {
            this.pages = Math.ceil(this.items / this.perPage);
            let tmpArr = [];
            for (let i = 0; i < this.items; i += this.perPage) {
              tmpArr.push(this.datas.slice(i, i + this.perPage));
            }
            this.selected_data = tmpArr[this.page - 1];
            tmpArr = [];
            for (let i = 0; i < this.items; i++) {
              tmpArr.push(this.datas[i].largeCategory);
            }
            this.largeCategory = Array.from(new Set(tmpArr));
          }
        })
        .catch((error) => {
          console.log(error);
          this.errorFlag = true;
        });
    },
    validate() {
      this.page = 1;
      this.selectedCategory = "";
      this.selectedSmc = "";
      this.datas = [];
      this.selected_data = [];
      this.unregistered = false;
      axios
        .post(
          "https://api.dataplatform-yamanashi.jp/registration-orion/validate",
          { mode: "validate" },
          { headers: { Authorization: "Bearer " + this.token } }
        )
        .then(() => {
          axios
            .get("https://api.dataplatform-yamanashi.jp/registration-orion", {
              headers: { Authorization: "Bearer " + this.token },
              params: {
                lc: "",
                sm: "",
                unregistered: this.unregistered,
              },
            })
            .then((response) => {
              this.datas = response.data;
              this.items = this.datas.length;
              this.pages = Math.ceil(this.items / this.perPage);
              let tmpArr = [];
              for (let i = 0; i < this.items; i += this.perPage) {
                tmpArr.push(this.datas.slice(i, i + this.perPage));
              }
              this.selected_data = tmpArr[this.page - 1];
              tmpArr = [];
              for (let i = 0; i < this.items; i++) {
                tmpArr.push(this.datas[i].largeCategory);
              }
              this.largeCategory = Array.from(new Set(tmpArr));
            })
            .catch((error) => {
              console.log(error);
              this.errorFlag = true;
            });
        })
        .catch((error) => {
          console.log(error);
          this.errorFlag = true;
        });
    },
  },
  mounted() {
    axios
      .get("https://api.dataplatform-yamanashi.jp/registration-orion", {
        headers: { Authorization: "Bearer " + this.token },
        params: {
          lc: "",
          sm: "",
          unregistered: this.unregistered,
        },
      })
      .then((response) => {
        this.datas = response.data;
        this.items = this.datas.length;
        this.pages = Math.ceil(this.items / this.perPage);
        let tmpArr = [];
        for (let i = 0; i < this.items; i += this.perPage) {
          tmpArr.push(this.datas.slice(i, i + this.perPage));
        }
        this.selected_data = tmpArr[this.page - 1];
        tmpArr = [];
        for (let i = 0; i < this.items; i++) {
          tmpArr.push(this.datas[i].largeCategory);
        }
        this.largeCategory = Array.from(new Set(tmpArr));
      })
      .catch((error) => {
        console.log(error);
        this.errorFlag = true;
      });
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
    nextUpload() {
      var now = new Date();
      var Year = now.getFullYear();
      var Month = now.getMonth() + 1;
      var day = now.getDate();
      var Hour = now.getHours();
      var Min = now.getMinutes();
      if (15 > Min && Min > 0) {
        Min = 15;
      } else if (30 > Min && Min > 15) {
        Min = 30;
      } else if (45 > Min && Min > 30) {
        Min = 45;
      } else {
        Min = 0;
        Hour = Hour + 1;
      }
      Year = Year.toString().padStart(2, "0");
      Month = Month.toString().padStart(2, "0");
      day = day.toString().padStart(2, "0");
      Hour = Hour.toString().padStart(2, "0");
      Min = Min.toString().padStart(2, "0");
      return Year + "/" + Month + "/" + day + " " + Hour + ":" + Min;
    },
  },
  components: {
    Loading,
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  margin: 36px 5%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.nowLoading {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
}

.item {
  margin-top: 40px;
  width: 90%;
}

.fillterSpase {
  width: 60%;
  margin-bottom: 12px;
}

.validateSpace {
  width: 30%;
  margin-bottom: 12px;
}

.card {
  margin-top: 36px;
  padding: 1vw;
}

.cardTitle {
  display: grid;
  grid-template-columns: 30px auto auto 30px;
  grid-template-rows: auto;
  justify-items: start;
  align-items: center;
  grid-template-areas: "filterIcon filterTitle . arrowIcon";
  font-size: 1.2vw;
  cursor: pointer;
}

.filterTitle {
  grid-area: filterTitle;
  font-size: 1.2vw;
  font-weight: 500;
}

.filterIcon {
  grid-area: filterIcon;
}

.arrowIcon {
  grid-area: arrowIcon;
}
.expand {
  padding: 28px 0;
}

.fillter {
  display: grid;
  padding: 2vw;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 0.5fr;
  grid-column-gap: 20px;
}

.validate {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  row-gap: 1vw;
}

.error {
  color: #d32f2f;
  background-color: #ffebee;
}

.nonTable {
  display: flex;
  width: 100%;
  align-items: flex-start;
  column-gap: 2vw;
}

.time {
  font-size: 1.6vw;
  font-weight: 500;
}

.table {
  position: relative;
}

.alert {
  width: 80%;
}
</style>
